/** Below this width the name column is capped, so at least three day columns sit beside it. */
export const PHONE_BELOW = 640
export const PHONE_NAME_W = 110
/** Width alone misses a phone on its side: as wide as a small desk, but the desk toolbar would leave the grid three rows. */
export const SCHEDULE_PHONE_QUERY = `(max-width: ${PHONE_BELOW - 0.02}px), (pointer: coarse) and (max-height: 500px)`

export const OWN_SCHEDULE_PATH = '/roster/my'

function bare(pathname: string): string {
  return pathname.replace(/\/+$/, '')
}

/** My schedule reads only `/api/roster/me`, so the roster section must not fetch the whole document for it. */
export function isOwnSchedulePath(pathname: string): boolean {
  return bare(pathname) === OWN_SCHEDULE_PATH
}

/** Where a phone reader lands instead of the Schedule: roster staff and managers keep the grid on a phone. */
export function rosterPhoneRedirect(pathname: string, isPhone: boolean, hasRosterRole: boolean): string | null {
  if (!isPhone || hasRosterRole) return null
  const path = bare(pathname)
  return path === '/roster' || path === '/roster/schedule' ? OWN_SCHEDULE_PATH : null
}

/** The frozen widths to draw: on a phone the name column is never wider than `PHONE_NAME_W`. */
export function phoneWidths(widths: readonly number[], phone: boolean): number[] {
  if (!phone) return [...widths]
  return widths.map((w, i) => (i === 0 ? Math.min(w, PHONE_NAME_W) : w))
}
